/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageSync = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.526 2.457a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 1 0V3.681c.011.008.012.023.024.03a4.474 4.474 0 0 1 2.156 2.686 4.468 4.468 0 0 1-.376 3.424 4.468 4.468 0 0 1-2.686 2.156.5.5 0 0 0 .28.961 5.47 5.47 0 0 0 3.283-2.636 5.462 5.462 0 0 0 .459-4.184 5.456 5.456 0 0 0-2.455-3.161h3.315a.5.5 0 0 0 .5-.5zM.474 12.457a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4.5a.5.5 0 0 0-1 0v3.276c-.011-.008-.012-.023-.024-.03a4.474 4.474 0 0 1-2.156-2.686 4.468 4.468 0 0 1 .376-3.424 4.468 4.468 0 0 1 2.686-2.156.5.5 0 0 0-.28-.961c-1.411.413-2.577 1.348-3.283 2.636a5.466 5.466 0 0 0 1.996 7.345H.974a.5.5 0 0 0-.5.5z"
    />
  </svg>
);

IconMessageSync.displayName = 'IconMessageSync';

IconMessageSync.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageSync);
IconMessageSync.displayName = 'IconMessageSync';
